export default function MetricsPage() {
  return (
    <div className="h-full overflow-y-auto p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Metrics</h1>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {['Performance', 'Battery History', 'Task Completion', 'Error Rate'].map((label) => (
          <div
            key={label}
            className="rounded-2xl bg-surface border border-border shadow-shell p-4 h-40 flex flex-col justify-between"
          >
            <p className="text-sm font-medium text-muted">{label}</p>
            <div className="h-20 flex items-end gap-1">
              {Array.from({ length: 12 }, (_, i) => (
                <div
                  key={i}
                  className="flex-1 rounded-sm bg-accent/20"
                  style={{ height: `${20 + Math.sin(i * 0.8) * 40 + 40}%` }}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
